import React, { useEffect, useState } from "react";
import { useParams } from 'react-router-dom';
import Select from 'react-select';
import { useTranslation } from "react-i18next";
import { useCookies } from "react-cookie";
import configVars from "../../config";

const AddNewTeam = (props) => {

    const [members, setMembers] = useState([]);
    const [teamName, setTeamName] = useState('');
    const [selectedMembers, setSelectedMembers] = useState([]);
    const [selectedManager, setSelectedManager] = useState();
    const [isError, setIsError] = useState(false);
    const [success, setSuccess] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [translation] = useTranslation("translations");
    const [loading, setLaoding] = useState(false);
    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const { organization_id, team_id, sub_teams } = useParams();

    useEffect(() => {

        if ( props?.members && props?.members.length > 0 ) {
            
            const memberOptions = props?.members.map( (member) => {
                return {value: member?.id, label: member?.name};
            });

            setMembers( memberOptions );
        }

        if ( sub_teams && props?.type === 'edit' ) {
            
            setTeamName(props?.teamData?.team_name);

            const selectedMemberOptions = props?.selectedMembers.map( (member) => {
                return {value: member?.id, label: member?.name};
            });

            setSelectedMembers(selectedMemberOptions);

            if ( props?.teamData && props?.members ) {

                const managerID = parseInt( props?.teamData?.manager_id, 10 );
                
                const managerData = props?.members.find(obj => {
                    return obj.id === managerID
                })

                if ( managerData ) {
                    setSelectedManager({value: managerData?.id, label: managerData?.name});
                }
            }

        }

    }, [props, sub_teams]);

    const handleManagerSelect = ( selectedOption ) => {

        setIsError(false);

        if ( selectedMembers && selectedMembers.length > 0 && selectedMembers.includes( selectedOption ) ) {
            
            setIsError(true);
            setErrorMsg('Manager cannot be a team member');

        } else {
            setSelectedManager( selectedOption );
        }
    }

    const handleMembersSelect = ( selectedOption ) => {

        setIsError(false);

        if ( selectedManager && Object.keys(selectedManager).length !== 0 && selectedOption.includes( selectedManager ) ) {
            
            setIsError(true);
            setErrorMsg('Manager cannot be a team member');

        } else {
            setSelectedMembers( selectedOption );
        }
    }

    const handleValidation = () => {

        let validated = true;

        if ( !teamName || teamName.length < 1 ) {
            validated = false;
        }

        if ( !selectedMembers || selectedMembers.length < 1 ) {
            validated = false;
        }

        if ( !selectedManager ) {
            validated = false;
        }

        return validated;

    }

    const handleSave = async () => {

        setIsError(false);
        setErrorMsg('');

        const validation = handleValidation();

        if ( ! validation ) {
            setIsError(true);
            setErrorMsg(translation("fill_required_fields"));

            return false;
        }

        setLaoding(true);

        let userRequestData = new FormData();
            userRequestData.append( 'token', cookies.sustainyou_user_jwt );
            userRequestData.append( 'team_name', teamName );
            userRequestData.append( 'team_manager', JSON.stringify(selectedManager) );
            userRequestData.append( 'team_members', JSON.stringify(selectedMembers) );
            userRequestData.append( 'company_id', organization_id );

            if ( team_id ) {
                userRequestData.append( 'parent_team', team_id );
            }

            if ( sub_teams && props?.type === 'edit' ) {
                userRequestData.append( 'type', 'update' );
                userRequestData.append( 'team_id', team_id );
            }

            const fetchUrl = `${configVars.apiUrl}sustainteams/v1/sustainsaveteam/`;

            try{

                const response = await fetch(
                    fetchUrl,
                    {
                    method: "POST",
                    headers: {
                        Authorization: `Basic ${configVars.auth}`,
                    },
                    body: userRequestData
                    }
                );
                
                const teamResponse = await response.json();
        
                if ( teamResponse ) {

                    if ( teamResponse.success === true ) {
                        setSuccess(true);
                        localStorage.removeItem( `sy_org_${organization_id}_data` );

                        if ( sub_teams && props?.type === 'edit' ) {
                            window.location.replace( `/organizations/${organization_id}/teams/${team_id}/` );
                        } else {
                            window.location.replace( `/organizations/${organization_id}/teams/` );
                        }
                        
                    } else {
                        setIsError(true);
                        setErrorMsg(teamResponse.message);
                    }

                    setTeamName('');
                    setSelectedMembers([]);
                    setSelectedManager(null);
                    
                    //console.log( teamResponse );

                }

            } catch( error ) {
                console.log( error );
                return error;
            }
        
        setLaoding(false);

    }

    return (
        <div className="mt-5">

            <h3>{ (props?.type && props?.type === 'edit') ? 'Uppdatera' : 'Lägg till ny'} team</h3>

            <div className="new-team-wrap mt-5" style={{ maxWidth: "600px" }}>

                {isError &&
                    <div className="alert alert-danger" role="alert">
                        {errorMsg}
                    </div>
                }

                {success &&
                    <div className="alert alert-success" role="alert">
                        Team successfully created.
                    </div>
                }

                <div className="mb-3">
                    { (props?.type && props?.type === 'edit') &&
                        <label className="form-label">Team namn</label>
                    }
                    <input type="text" className="form-control bg-white" placeholder="Team namn" value={teamName} onChange={(e) => setTeamName(e.target.value)} />
                </div>

                <div className="mb-3">
                    { (props?.type && props?.type === 'edit') &&
                        <label className="form-label">Välj team manager</label>
                    }
                    <Select options={members} placeholder="Välj team manager" value={selectedManager} onChange={handleManagerSelect} />
                </div>

                <div className="mb-3">
                    { (props?.type && props?.type === 'edit') &&
                        <label className="form-label">Välj Medlemmar</label>
                    }
                    <Select options={members} isMulti={true} placeholder="Välj Medlemmar" value={selectedMembers} onChange={handleMembersSelect} />
                </div>

                <div className="mt-3">
                    <button type="button" className="btn btn-secondary w-100" onClick={() => handleSave()}>
                        {!loading &&
                            <i className="fa fa-floppy-o" aria-hidden="true"></i>
                        }
                        {loading &&
                            <div className="spinner-border text-light spinner-border-sm" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                        }
                        <span className="ms-2">{ (props?.type && props?.type === 'edit') ? 'Uppdatera' : 'Spara'} team</span>
                    </button>
                </div>

            </div>

        </div>
    )

}

export default AddNewTeam;